// extracted by mini-css-extract-plugin
export default {"title":"delete_title__mZIKa","buttonPart":"delete_buttonPart__7+YrC","buttonCancel":"delete_buttonCancel__k5ZWO","buttonDelete":"delete_buttonDelete__Ot5iR"};